import { render, staticRenderFns } from "./TransactionsPerSalesChannel.vue?vue&type=template&id=42fdca54&scoped=true&"
import script from "./TransactionsPerSalesChannel.vue?vue&type=script&lang=js&"
export * from "./TransactionsPerSalesChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fdca54",
  null
  
)

export default component.exports